var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{ref:"pc_common",class:[
    'page-common', 
    _vm.customClassProp, 
    `detect_deviece_${_vm.deviceType}`, 
    `state_${_vm.deviceType}`,
    `design-type-${_vm.domainConfig?.designType || 1}`,
  ]},[_c('HeadBar',{attrs:{"title":_vm.domainConfig['title'],"logo":_vm.domainConfig['icon'],"deviceType":_vm.deviceType}}),_vm._t("default"),_c('FootBar',{attrs:{"deviceType":_vm.deviceType}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }